import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  FormControl,
  FormGroup,
  Grid,
  Paper,
  Toolbar,
} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import Fab from "@material-ui/core/Fab";
import Icon from "@material-ui/core/Icon";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import Search from "@material-ui/icons/Search";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Chart from "react-google-charts";
import { ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";

import datetimeHelper from "../../helper/datetime-helper";
import { globalHistory } from "../../history";
import { mapActionsToProps } from "./../../redux/report/agent";

class ReportAgent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
    };
  }

  componentDidMount() {
    this.itemInit();
    this.history = globalHistory();
  }

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            default: {
              if (key.startsWith("gte") || key.startsWith("lte")) {
                if (key == "gte") {
                  and.push({
                    time: {
                      gte: datetimeHelper.toFormat(
                        this.state.filters.where.gte,
                        "YYYY-MM-DD startDay"
                      ),
                    },
                  });
                  where.and = and;
                } else {
                  and.push({
                    time: {
                      lte: datetimeHelper.toFormat(
                        this.state.filters.where.lte,
                        "YYYY-MM-DD endDay"
                      ),
                    },
                  });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.getListReportAgent(filters.where.gte, filters.where.lte);
  }

  handleChange = (name) => {
    return (e) => {
      return this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleDateChangeStart = (gte) => {
    const { filters } = this.state;
    filters.where.gte = datetimeHelper.toFormat(gte, "YYYY-MM-DD");
    this.setState({ gte });
  };

  handleDateChangeEnd = (lte) => {
    const { filters } = this.state;
    filters.where.lte = datetimeHelper.toFormat(lte, "YYYY-MM-DD");
    this.setState({ lte });
  };

  render() {
    const { classes, agentReport } = this.props;
    const { filters } = this.state;
    const agentReportResult =
      typeof agentReport === "object"
        ? Object.keys(agentReport).map((key) => agentReport[key])
        : agentReport;
    const inboundReportData = [["Điện thoại viên", "Kết nối"]];
    const outboundReportData = [["Điện thoại viên", "Kết nối"]];
    for (const key in agentReportResult) {
      if (agentReportResult.hasOwnProperty(key)) {
        const value = agentReportResult[key];
        if (value.agent.agentCode === undefined) {
          value.agent.agentCode = "Mã nhân viên chưa xác định";
        }
        inboundReportData.push([
          value.agent.agentCode,
          value.inboundCalls.answeredCalls,
        ]);
        outboundReportData.push([
          value.agent.agentCode,
          value.outboundCalls.answeredCalls,
        ]);
      }
    }
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid
                      container
                      spacing={24}
                      style={{ alignItems: "center" }}>
                      {/* <Grid item md={3}>
                                                <TextValidator
                                                    id="outlined-full-width"
                                                    margin="normal"
                                                    label="Máy lẻ"
                                                    variant="outlined"
                                                    className={classes.input}
                                                    onChange={this.handleSearch}
                                                    value={filters.where.extension}
                                                    name="extension"
                                                />
                                            </Grid> */}
                      <Grid item md={3}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian bắt đầu"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.gte}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeStart}
                          name="gte"
                          keyboard
                          ampm={false}
                        />
                      </Grid>
                      <Grid item md={3}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian kết thúc"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.lte}
                          maxDate={new Date()}
                          minDate={filters.where.gte}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeEnd}
                          name="lte"
                          keyboard
                          ampm={false}
                        />
                      </Grid>
                      <Grid item md={3}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            onClick={this.handleSubmit}>
                            <Search />
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        {agentReportResult.length != 0 ? (
          <Grid container spacing={24}>
            <Grid item md={6}>
              <Paper
                style={{
                  marginTop: 15,
                  justifyContent: "center",
                  display: "flex",
                  backgroundColor: "#fff",
                  color: "#000",
                }}>
                <Chart
                  width={"100%"}
                  height={"600px"}
                  chartType="BarChart"
                  loader={<div>Loading Chart</div>}
                  data={inboundReportData}
                  options={{
                    title: "Báo cáo năng suất điện thoại viên ( Cuộc gọi vào )",
                    isStacked: true,
                    hAxis: {
                      title: "Số lượng cuộc gọi",
                      minValue: 0,
                    },
                    vAxis: {
                      title: "Điện thoại viên",
                    },
                  }}
                  // For tests
                  rootProps={{ "data-testid": "3" }}
                />
              </Paper>
            </Grid>
            <Grid item md={6}>
              <Paper
                style={{
                  marginTop: 15,
                  justifyContent: "center",
                  display: "flex",
                  backgroundColor: "#fff",
                  color: "#000",
                }}>
                <Chart
                  width={"100%"}
                  height={"600px"}
                  chartType="BarChart"
                  loader={<div>Loading Chart</div>}
                  data={outboundReportData}
                  options={{
                    title: "Báo cáo năng suất điện thoại viên ( Cuộc gọi ra )",
                    isStacked: true,
                    hAxis: {
                      title: "Số lượng cuộc gọi",
                      minValue: 0,
                    },
                    vAxis: {
                      title: "Điện thoại viên",
                    },
                  }}
                  // For tests
                  rootProps={{ "data-testid": "3" }}
                />
              </Paper>
            </Grid>
          </Grid>
        ) : null}
        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell
                  rowSpan="3"
                  style={{ borderRight: "1px solid rgba(224, 224, 224, 1)" }}>
                  Mã nhân viên
                </TableCell>
                <TableCell
                  rowSpan="3"
                  style={{ borderRight: "1px solid rgba(224, 224, 224, 1)" }}>
                  Tài khoản
                </TableCell>
                <TableCell
                  rowSpan="3"
                  style={{ borderRight: "1px solid rgba(224, 224, 224, 1)" }}>
                  Nhóm
                </TableCell>
                {/* </TableRow>
                            <TableRow> */}
                <TableCell
                  colSpan="3"
                  style={{ borderRight: "1px solid rgba(224, 224, 224, 1)" }}>
                  Cuộc gọi vào
                </TableCell>
                <TableCell
                  colSpan="3"
                  style={{ borderRight: "1px solid rgba(224, 224, 224, 1)" }}>
                  Cuộc gọi ra
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Tổng</TableCell>
                <TableCell>Kết nối</TableCell>
                <TableCell
                  style={{ borderRight: "1px solid rgba(224, 224, 224, 1)" }}>
                  ACD
                </TableCell>
                <TableCell>Tổng</TableCell>
                <TableCell>Kết nối</TableCell>
                <TableCell
                  style={{ borderRight: "1px solid rgba(224, 224, 224, 1)" }}>
                  ACD
                </TableCell>
                <TableCell>Chi tiết</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {agentReportResult
                ? agentReportResult.map((row, key) => {
                    return (
                      <TableRow key={key}>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                          }}>
                          {row.agent.agentCode}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                          }}>
                          {row.agent.agentFullname}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                          }}>
                          {row.agent.agentGroup}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.inboundCalls.total}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.inboundCalls.answeredCalls}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                          }}>
                          <Toolbar title="Thời lượng trung bình">
                            {datetimeHelper.secondToHHMMSS(
                              row.inboundCalls.acd
                            )}
                          </Toolbar>
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.outboundCalls.total}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.outboundCalls.answeredCalls}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                          }}>
                          <Toolbar title="Thời lượng trung bình">
                            {datetimeHelper.secondToHHMMSS(
                              row.outboundCalls.acd
                            )}
                          </Toolbar>
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Icon
                            onClick={() =>
                              this.history.push(
                                `${process.env.REACT_APP_PATH}/mini-crm/report/agent-detail/${row.agent.agentId}`
                              )
                            }>
                            visibility
                          </Icon>
                        </TableCell>
                      </TableRow>
                    );
                  })
                : null}
            </TableBody>
          </Table>
        </Paper>
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  charts: {
    backgroundColor: "#fff",
  },
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
    justifyContent: "center",
    display: "flex",
  },
  table: {
    minWidth: 700,
  },
  input: {
    width: "100%",
  },
  form: {
    width: "100%",
  },
});

ReportAgent.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  agentReport: state.reportAgent.report,
});

ReportAgent = connect(mapStateToProps, mapActionsToProps)(ReportAgent);
export default withStyles(styles)(ReportAgent);
